export default __webpack_public_path__ + "maps-examples-constraining-gestures-thumbnail-960-29100374ba2831b26baba7a3cd7c902a.webp";